import React from "react";
import {
  FormControl,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { generateTestId } from "app/functions";

export const HotSelect = ({
  name,
  control,
  label,
  options = [],
  required = false,
  helperText,
  rules = {},
  autocomplete = false,
  multiple = false,
  placeholder = "בחר...",
  testID,
  ...rest
}) => {
  // If required is true, add it to the rules
  if (required && !rules.required) {
    rules.required = "This field is required";
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, value, ...field },
        fieldState: { error },
      }) => (
        <FormControl fullWidth error={!!error} required={required}>
          {label && (
            <Typography
              variant="inputLabel"
              component="label"
              color={error ? "error" : "text.inputLabel"}
            >
              {label}
            </Typography>
          )}
          {
            <Autocomplete
              {...rest}
              multiple={multiple}
              options={options}
              getOptionLabel={(option) => {
                // Handle both object options and primitive values
                if (typeof option === "object") {
                  return option.label || "";
                }
                return option;
              }}
              isOptionEqualToValue={(option, value) => {
                if (!option || !value) return false;
                return option.value === value.value;
              }}
              value={value}
              onChange={(_, newValue) => {
                onChange(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...field}
                  error={!!error}
                  testID={generateTestId(testID, `${name}-select`)}
                  placeholder={placeholder}
                  helperText={error ? error.message : helperText}
                  sx={{
                    '& .MuiFormHelperText-root': {
                      marginTop: "0px",
                      minHeight: "1rem",
                      position: "absolute",
                      bottom: -20,
                      visibility: (error || helperText) ? 'visible' : 'hidden'
                    }
                  }}
                />
              )}
            />
          }
        </FormControl>
      )}
    />
  );
};

export default HotSelect;
